import { render, staticRenderFns } from "./WhdCustomer.vue?vue&type=template&id=151d2205&lang=pug&"
import script from "./WhdCustomer.vue?vue&type=script&lang=js&"
export * from "./WhdCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports